import { ExpansionPanel, ExpansionPanelList, ExpansionPanelListItem } from 'gatsby-theme-apollo-docs';
import * as React from 'react';
export default {
  ExpansionPanel,
  ExpansionPanelList,
  ExpansionPanelListItem,
  React
};